import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Plus, Trash2 } from "lucide-react";

interface TechnicalSpec {
  label: string;
  value: string;
}

interface TechnicalSpecsInputProps {
  value: TechnicalSpec[];
  onChange: (value: TechnicalSpec[]) => void;
}

export function TechnicalSpecsInput({
  value = [],
  onChange
}: TechnicalSpecsInputProps) {
  const [newLabel, setNewLabel] = useState("");
  const [newValue, setNewValue] = useState("");

  const handleAddSpec = () => {
    if (newLabel.trim() && newValue.trim()) {
      onChange([...value, { label: newLabel.trim(), value: newValue.trim() }]);
      setNewLabel("");
      setNewValue("");
    }
  };

  const handleRemoveSpec = (index: number) => {
    onChange(value.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-3">
      <Label>Especificaciones Técnicas</Label>
      <div className="grid grid-cols-2 gap-2">
        <Input
          value={newLabel}
          onChange={(e) => setNewLabel(e.target.value)}
          placeholder="Nombre de la especificación"
          className="col-span-1"
        />
        <div className="col-span-1 flex gap-2">
          <Input
            value={newValue}
            onChange={(e) => setNewValue(e.target.value)}
            placeholder="Valor"
            className="flex-1"
          />
          <Button
            type="button"
            variant="outline"
            onClick={handleAddSpec}
            size="icon"
          >
            <Plus className="h-4 w-4" />
          </Button>
        </div>
      </div>
      <div className="mt-2 space-y-2">
        {value.map((spec, index) => (
          <div
            key={index}
            className="flex items-center gap-2 p-2 rounded-md bg-muted/50 group"
          >
            <div className="flex-1 grid grid-cols-2 gap-2">
              <span className="text-sm font-medium">{spec.label}:</span>
              <span className="text-sm">{spec.value}</span>
            </div>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="opacity-0 group-hover:opacity-100 transition-opacity"
              onClick={() => handleRemoveSpec(index)}
            >
              <Trash2 className="h-4 w-4 text-destructive" />
            </Button>
          </div>
        ))}
        {value.length === 0 && (
          <div className="text-muted-foreground text-sm italic text-center py-4">
            No hay especificaciones técnicas definidas.
          </div>
        )}
      </div>
    </div>
  );
}
